import { render } from "./PreconfiguredEntities.vue?vue&type=template&id=5f6de103&lang=pug"
import script from "./PreconfiguredEntities.vue?vue&type=script&lang=js"
export * from "./PreconfiguredEntities.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__